import { Fragment } from "react";
import { Grid, MenuItem, Autocomplete } from "@mui/material";

import { Label, TextField, LoadingButton } from "../../components";

export default function VisitorFormDisplay({ formikProps, countryCodes }) {
  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Label
            required
            title="First Name"
            name="first_name"
            formikProps={formikProps}
            sx={{
              fontWeight: 600,
              color: "#424242",
              fontSize: "14px",
              marginBottom: "8px",
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            size="small"
            required
            name="first_name"
            placeholder="First Name"
            formikProps={formikProps}
            style={{ marginTop: "0px" }}
          />
        </Grid>

        <Grid item xs={6}>
          <Label
            title="Last Name"
            name="last_name"
            formikProps={formikProps}
            sx={{
              fontWeight: 600,
              color: "#424242",
              fontSize: "14px",
              marginBottom: "8px",
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            size="small"
            name="last_name"
            placeholder="Last Name"
            formikProps={formikProps}
            style={{ marginTop: "0px" }}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="Email Address"
            name="email"
            formikProps={formikProps}
            sx={{
              fontWeight: 600,
              color: "#424242",
              fontSize: "14px",
              marginBottom: "8px",
            }}
          />
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            size="small"
            required
            name="email"
            placeholder="Email Address"
            formikProps={formikProps}
            style={{ marginTop: "0px" }}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="Phone Number"
            name="phone_number"
            formikProps={formikProps}
            sx={{
              fontWeight: 600,
              color: "#424242",
              fontSize: "14px",
              marginBottom: "8px",
            }}
          />
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={4.5}>
              <Autocomplete
                disableClearable
                options={
                  countryCodes && countryCodes.length > 0
                    ? countryCodes
                    : [
                        {
                          alpha2_code: "IN",
                          dial_code: "91",
                          country_name: "India",
                        },
                      ]
                }
                getOptionLabel={(option) => {
                  const code = String(
                    option.dial_code || option.country_code || option.code || ""
                  ).replace("+", "");
                  const name =
                    option.country_name || option.country || option.name || "";
                  return name ? `+${code} (${name})` : `+${code}`;
                }}
                value={
                  (countryCodes &&
                    countryCodes.find(
                      (item) =>
                        (item.alpha2_code ||
                          item.code ||
                          item.country_code ||
                          item.dial_code ||
                          "") === formikProps.values.country_code
                    )) ||
                  (formikProps.values.country_code === "IN"
                    ? {
                        alpha2_code: "IN",
                        dial_code: "91",
                        country_name: "India",
                      }
                    : null)
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    const val =
                      newValue.alpha2_code ||
                      newValue.code ||
                      newValue.country_code ||
                      newValue.dial_code ||
                      "";
                    formikProps.setFieldValue("country_code", val);
                  }
                }}
                onBlur={() => formikProps.setFieldTouched("country_code", true)}
                isOptionEqualToValue={(option, value) => {
                  const optVal =
                    option.alpha2_code ||
                    option.code ||
                    option.country_code ||
                    option.dial_code ||
                    "";
                  const valVal =
                    value.alpha2_code ||
                    value.code ||
                    value.country_code ||
                    value.dial_code ||
                    "";
                  return optVal === valVal;
                }}
                renderOption={(props, option) => {
                  const code = String(
                    option.dial_code || option.country_code || option.code || ""
                  ).replace("+", "");
                  const name =
                    option.country_name || option.country || option.name || "";
                  const val =
                    option.alpha2_code ||
                    option.code ||
                    option.country_code ||
                    option.dial_code ||
                    "";
                  return (
                    <li {...props} key={val} style={{ fontSize: "14px" }}>
                      {name ? `+${code} (${name})` : `+${code}`}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                    error={
                      formikProps.touched.country_code &&
                      Boolean(formikProps.errors.country_code)
                    }
                    helperText={
                      formikProps.touched.country_code &&
                      formikProps.errors.country_code
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={7.5}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                required
                name="phone_number"
                placeholder="Phone Number"
                formikProps={formikProps}
                inputProps={{
                  type: "tel",
                  // pattern: "[6-9]\\d*",
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="Gender"
            name="gender"
            formikProps={formikProps}
            sx={{
              fontWeight: 600,
              color: "#424242",
              fontSize: "14px",
              marginBottom: "8px",
            }}
          />
          <TextField
            select
            fullWidth
            margin="normal"
            variant="outlined"
            size="small"
            required
            name="gender"
            placeholder="Select Gender"
            label="Select Gender"
            style={{ marginTop: "0px" }}
            value={formikProps.values.gender}
            onChange={formikProps.handleChange}
            onBlur={formikProps.handleBlur}
            error={
              formikProps.touched.gender && Boolean(formikProps.errors.gender)
            }
            helperText={formikProps.touched.gender && formikProps.errors.gender}
          >
            {[
              { id: "Male", name: "Male" },
              { id: "Female", name: "Female" },
              { id: "Other", name: "Other" },
            ].map((item, index) => (
              <MenuItem key={index} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} mt={3}>
          <LoadingButton
            type="submit"
            variant="contained"
            fullWidth
            loading={formikProps.isSubmitting}
            disabled={!formikProps.isValid}
            style={{ padding: "10px 12.5px", fontWeight: 700 }}
          >
            Sign Up
          </LoadingButton>
        </Grid>
      </Grid>
    </Fragment>
  );
}
